import { getApi, getApiWithParam, postApi } from "./api";

export const addFollowUpUser = async (userData) => {
    try {
        const response = await postApi(
            "/FollowUp/AddFolloUpOrder",
            userData
        );
        return response;

    } catch (error) {
        console(error);
        throw error.response?.data || error.message;
    }
};
export const GetAllFolloUpUser = async (userId) => {
    return await getApi(
        `/FollowUp/GetAllFolloUpUser/${userId}`
    );
};
export const FollowUpOrders = async (
  reOrder,
  userId,
  statusId,
  isComplete,
  isringing,
  isDeny,
  startDate,
  endDate,
  config = {}
) => {
  return await getApiWithParam("/Order/FollowUpOrders/", {
    params: {
      reOrder,
      userId,
      statusId,
      isComplete,
      isringing,
      isDeny,
      startDate,
      endDate,
    },
     ...config,
  });
};

export const addFollowUpRemarks = async (followUpRemarks) => {
    try {
        const response = await postApi(
            "/Order/AddRemarks",followUpRemarks
        );
        return response;

    } catch (error) {
        console(error);
        throw error.response?.data || error.message;
    }
};

export const FollowUpPunchOrders = async (
  reOrder,
  userId,
  statusId,
  isComplete,
  isringing,
  isDeny,
  config = {}
) => {
  return await getApiWithParam("/Order/FollowUpOrders/", {
    params: {
      reOrder,
      userId,
      statusId,
      isComplete,
      isringing,
      isDeny,
    },
     ...config,
  });
};

export const UpdateIsCompleteStatus = async (assingId) => {
  try {
    const response = await postApi(`/FollowUp/UpdateIscompleteDone?assingId=${assingId}`);
    return response.data;
  } catch (error) {
    console.error("Update Status Error:", error);
    throw error;
  }
};
export const InterestedFollowUp = async (
  reOrder,
  userId,
  statusId,
  isComplete,
  isringing,
  isDeny,
  startDate,
  endDate,
  config = {}
) => {
  return await getApiWithParam("/Order/InterestedFollowUp/", {
    params: {
      reOrder,
      userId,
      statusId,
      isComplete,
      isringing,
      isDeny,
      startDate,
      endDate,
    },
     ...config,
  });
};